import { schemaTypes, dateFormat } from "../../../../constants/constants";
import ReportAPIs from "../../../../APIs/ReportAPIs";
import axios from "axios";
import _ from "lodash";
import moment from "moment";

const alarm_types = ["standard", "csa", "custom"];
const filter_alarms = [
  /Harsh_Acceleration/,
  // /Crash_Occurred/,
  // Crash_detection_event
  /Harsh_braking/,
  // /LOW_VOLTAGE/,
  // /DEVICEPLUGGEDOUT/,
  /Idling_Long_\w+/,
  /Idling_Short_\w+/,
];

export function duration(ms) {
  if (!ms) return "N/A";
  if (ms < 60 * 1000) {
    let dur = Math.floor(ms / 1000);
    if (dur < 2) return "a second";
    return dur + " seconds";
  }
  if (ms < 60 * 60 * 1000) {
    let minutes = Math.floor(ms / 1000 / 60);
    let seconds = Math.floor((ms % (1000 * 60)) / 1000);
    let dur = minutes + " min ";
    if (seconds) dur += seconds + " sec";
    return dur;
  }
  return moment.duration(ms).humanize();
}

const getHistory = (schema, data, store) => {
  let handleSuccess = (resp) => {
    /* debug/remove */
    let diagmsg = [];
    if (resp[1].length === 0) diagmsg.push("no rpm");
    else {
      let rpm = _.uniq(resp[1].map((f) => f.value));
      if (rpm.length === 1) diagmsg.push("rpm constant " + rpm[0]);
    }
    if (resp[6].length === 0) diagmsg.push("no speed");
    else {
      let spd = _.uniq(resp[6].map((f) => f.value));
      if (spd.length === 1) diagmsg.push("speed constant " + spd[0]);
    }
    if (diagmsg.length === 0) diagmsg = "okay";
    else diagmsg = diagmsg.join(",");
    let { vehicleno, vehiclemodel, devicetype } = data.vehicle[0].data;
    let vrct = [vehicleno, vehiclemodel, devicetype, diagmsg];
    if (!window.verdict) window.verdict = [];
    window.verdict.push(vrct);
    console.log(vrct);
    /* debug end */
    schema.content[0].ref.setBusy(false);
    window.setReportWindowTabBusy(this.schema, false);
    let vid = data.vehicle[0].id;
    let alarms = _.pick(resp[2][vid], alarm_types);
    alarms = _.values(alarms).flat(); // pick from alarm categories
    alarms = alarms.filter((f) =>
      filter_alarms.map((p) => p.test(f.alarmtype)).includes(true)
    ); // filter alarms from list
    resp[2] = alarms;
    resp[4] = resp[4][vid]; // refuel
    resp[5] = resp[5][vid]; // pilferage
    resp[7] = resp[7][vid] || []; // summary
    this.schema.content[0].ref.setData(resp);
    window.afrdata = resp;
  };
  let body = {
    vehicleid: data.vehicle[0].data.vehicleid,
    starttime: data.starttime.unix() * 1000,
    endtime: data.endtime.unix() * 1000,
  };
  if (window.showNoGpsFixData === true) {
    body.fixqfilter = false;
  }
  let body2 = Object.assign({}, body, { vehicleid: [body.vehicleid] });
  schema.content[0].ref.setBusy(true);
  window.setReportWindowTabBusy(this.schema, true);
  axios
    .all([
      ReportAPIs.getRTGPS(body),
      ReportAPIs.getRPMInfo(body),
      ReportAPIs.getAlarmHistory(body),
      ReportAPIs.getFuelLevelInfo(body),
      ReportAPIs.getRefuelHistory(body),
      ReportAPIs.pilferageReport(body),
      ReportAPIs.getSpeedInfo(body),
      ReportAPIs.getSummaryReport(body),
    ])
    .then(handleSuccess);
  // ReportAPIs.getRTGPS(body).then(handleSuccess);
};

const changeVehicle = function (v) {
  window.saveVehicleState(v);
};

export const downloadCSV = (csv, filename) => {
  let link = document.createElement("a");

  let csvData = new Blob([csv], { type: "text/csv" });
  let csvUrl = URL.createObjectURL(csvData);
  link.href = csvUrl;

  link.style.cssText += ";visibility:hidden";
  link.download = filename + ".csv";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const download = (schema, dt, store) => {
  let data = this.schema.content[0].ref.getData();
  let csv = "";
  csv += dt.vehicle[0].data.vehicleno + "\n\n";
  csv +=
    [
      ["Total distance", data.distance],
      ["Mileage", data.mileage],
      ["Total duration", data.duration],
      ["Fuel consumption", data.fuelused],
      ["Redzoning", data.redzoning],
      ["Refuel", data.refuel],
      ["Pilferage", data.pilferage],
    ]
      .map((f) => f.join(","))
      .join("\n") + "\n\n";
  csv += "Refuels\n";
  if (data.refuels.length)
    csv +=
      data.refuels
        .map((p) =>
          [
            p.refuelLitres,
            moment(p.starttime).format(dateFormat),
            '"' + p.address + '"',
          ].join(",")
        )
        .join("\n") + "\n\n";
  else csv += "No refuels\n\n";
  csv += "Pilferages\n";
  if (data.pilferages.length)
    csv +=
      data.pilferages
        .map((p) =>
          [
            p.pilferageLitres,
            moment(p.starttime).format(dateFormat),
            '"' + p.address + '"',
          ].join(",")
        )
        .join("\n") + "\n\n";
  else csv += "No pilferage\n\n";
  // csv += 'Idling,Duration,Location\n';
  // csv += data.idling.filter(f => (f.endtime - f.starttime) > 10 * 60 * 1000).map(i => [
  //     moment(i.starttime).format(dateFormat),
  //     duration(i.endtime - i.starttime),
  //     '"' + i.address + '"',
  //     '"https://maps.google.com?q=' + i.lat + ',' + i.lng + '"',
  // ].join(',')).join('\n') + '\n\n';
  csv += "Alert,Date,Duration,Location\n";
  if (data.alarms.length)
    csv += data.alarms
      .map((a) =>
        [
          a.alarmtype,
          moment(a.time).format(dateFormat),
          duration(a.duration),
          '"' + a.address + '"',
        ].join(",")
      )
      .join("\n");
  else csv += "No alarms\n";
  downloadCSV(csv, "advanced_fuel_report");
};

const schema = {
  key: "advanced_fuel_report",
  name: "Performance Report",
  toolbar: [
    {
      key: "vehicle",
      type: schemaTypes.MULTI_SELECT,
      singleSelect: true,
      onItemChange: changeVehicle.bind(this),
      storeData: (state) => {
        return {
          data: (() => {
            let newMap = {};
            for (let idx in state.vehicleMap) {
              if (idx.indexOf("user") === -1) {
                newMap[idx] = state.vehicleMap[idx];
              }
            }
            return newMap;
          })(),
          name: "vehicleno",
          id: "vehicleid",
        };
      },
      defaultValue: () => {
        return {
          data: window.selectedVehicles.map((i) => {
            return i.id;
          }),
          updatedAt: window.selectedVehiclesUpdatedAt,
        };
      },
    },
    {
      key: "starttime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "Start Date",
      model: Date.now() - 1000 * 60 * 60 * 24,
    },
    {
      key: "endtime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "End Date",
      model: moment(Date.now()).add(1, "day").startOf("day"),
    },
    { key: "limit", type: schemaTypes.INPUT_NUMBER, model: 80 },
    {
      key: "get_history",
      type: schemaTypes.BUTTON,
      name: "Get Report",
      onClick: getHistory,
    },
    {
      key: "download",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-download",
      onClick: download,
    },
  ],
  content: [
    {
      key: "report",
      type: schemaTypes.ADVANCED_FUEL_REPORT,
      position: { width: 12, height: 12, left: 0, top: 0 },
    },
  ],
};
export default schema;
